import {useTranslation} from "react-i18next";
import {css} from "@emotion/react";
import {pb} from "@pg-design/helpers-css";
import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons";

import {breakpoints} from "../../../common/app/styles/breakpoints";

const SLIDER_BUTTON_BG = "rgba(255, 255, 255, 0.12)";

interface ILandingMarketNewsSliderNavProps {
    activeArticleId: string;
    onChange: (articleId: string) => void;
    tabs: Array<{title: string; value: string}>;
}

export const LandingMarketNewsSliderNav = ({tabs, activeArticleId, onChange}: ILandingMarketNewsSliderNavProps) => {
    const {t} = useTranslation();

    if (tabs.length <= 1) {
        return null;
    }

    const currentIndex = tabs.findIndex((tab) => tab.value === activeArticleId);
    const safeIndex = currentIndex >= 0 ? currentIndex : 0;

    const goToPrev = () => {
        const prevIndex = (safeIndex - 1 + tabs.length) % tabs.length;

        onChange(tabs[prevIndex].value);
    };

    const goToNext = () => {
        const nextIndex = (safeIndex + 1) % tabs.length;

        onChange(tabs[nextIndex].value);
    };

    return (
        <nav css={[sliderNav, mobileSliderNav]} aria-label={t("landing.market_news.recommended")}>
            <button
                type="button"
                css={sliderButton}
                onClick={goToPrev}
                aria-label={t("landing.market_news.prev_article")}
            >
                <ChevronLeftIcon size="2" wrapperSize="4.8" wrapperColor={SLIDER_BUTTON_BG} fill="#fff" />
            </button>

            <button
                type="button"
                css={sliderButton}
                onClick={goToNext}
                aria-label={t("landing.market_news.next_article")}
            >
                <ChevronRightIcon size="2" wrapperSize="4.8" wrapperColor={SLIDER_BUTTON_BG} fill="#fff" />
            </button>
        </nav>
    );
};

const sliderNav = css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
    ${pb(3)};
`;

const mobileSliderNav = css`
    @media (min-width: ${breakpoints.sm}) {
        display: none;
    }
`;

const sliderButton = css`
    display: inline-flex;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
`;
